import { getFallbackValueIfNull } from 'owa-options-core';
import getStore from '../data/store/store';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
/*
 * Gets the fallback value for reminder option in events and invitaion settings
 */
export function getReminderTime() {
    return getFallbackValueIfNull(getStore().defaultReminderTime, getCalendarConfiguration().DefaultReminderTime);
}
//# sourceMappingURL=getReminderTime.js.map